import { render, staticRenderFns } from "./TransferReport.vue?vue&type=template&id=20d8ba85&scoped=true"
import script from "./TransferReport.vue?vue&type=script&lang=js"
export * from "./TransferReport.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/inventory.css?vue&type=style&index=0&id=20d8ba85&prod&scoped=true&lang=css&external"
import style1 from "./TransferReport.vue?vue&type=style&index=1&id=20d8ba85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8ba85",
  null
  
)

export default component.exports